module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0001.973d0b07.jpg";